// src/components/ICTSalesCard/ICTBillInvoiceInsert.jsx

import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { createBillInvoice } from "../../../../../store/billInvoiceSlice";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import "../../../../../Styles/Common.css";
export default function ICTBillInvoiceInsert({ salesCard,ictName,batchStartDate,batchStartTime,batchEndDate,batchEndTime,ictLocation,ictStudyMode,duration,trainerName,tour,travel,accom,miscSum,dcCost,totalTrainerCost,totalExpenses,ictMrp,sellPrice,grossRevenue,netRevenue, onClose }) {
  const dispatch = useDispatch();

  // initialize form with props.salesCard values where possible
  const [form, setForm] = useState({
    billedToPerson: "",
    billedToOrg: "",
    billedToAddress: "",
    billedToCountry: "",
    clientContact: "",
    clientEmail: "",
    clientGSTIN: "",
    billedToState: "",

    ictName: ictName || "",
    trainerName: trainerName ?? salesCard?.trainerName ?? "",
    tcId:      salesCard?.trainingCard_id || "",

    batchStartDate: batchStartDate || "",
    batchStartTime: batchStartTime || "",
    batchEndDate:   batchEndDate || "",
    batchEndTime:   batchEndTime || "",

    isStandard: salesCard?.isCustom ? "Custom" : "Standard",
    isPublic:   salesCard?.isPublic   ? "Public" : "Private",

    totalDuration: duration || 0,
    location:      ictLocation || "",
    studyMode:     ictStudyMode || "",

    tourCost:          tour || 0,
    travelCost:        travel || 0,
    accommodationCost: accom || 0,
    miscCost:          miscSum || 0,
    dcCost:            dcCost || 0,
    trainerCost:       totalTrainerCost || 0,

    totalExpense: totalExpenses || 0,
    ictMrp:       ictMrp || 0,
    ictSellPrice: sellPrice || 0,
    gstPer:       0,
    grossRev:     grossRevenue || 0,
    netRev:       netRevenue || 0,

    receivingCurrency: "INR",
    receivingAmt: 0,        // amount in foreign currency (if any)
    inrConvertRate: 1,      // conversion rate to INR
    status: "A",
  });

  // recalc totals whenever inputs change
  useEffect(() => {
    const {
      tourCost, travelCost, accommodationCost, miscCost, dcCost, trainerCost,
      ictMrp, ictSellPrice, gstPer,
    } = form;

    const totalExpense =
      tourCost + travelCost + accommodationCost + miscCost + dcCost + trainerCost;
    const grossRev = ictSellPrice;
    const gstAmount = (gstPer / 100) * grossRev;
    const netRev = grossRev - totalExpense + gstAmount;

    setForm((f) => ({
      ...f,
      totalExpense,
      grossRev,
      netRev,
    }));
  }, [
    form.tourCost,
    form.travelCost,
    form.accommodationCost,
    form.miscCost,
    form.dcCost,
    form.trainerCost,
    form.ictSellPrice,
    form.gstPer,
  ]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm((f) => ({ ...f, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      await dispatch(createBillInvoice(form)).unwrap();
      toast.success("Invoice created!");
      onClose();
    } catch (err) {
      toast.error("Failed to create invoice.");
    }
  };

  return (
    <div className="invoice-form-container">
      <h3>Generate Bill Invoice</h3>
      <form onSubmit={handleSubmit}>
        <section className="form-section">
          <h4>Bill To</h4>
          <div className="form-grid">
            <div className="form-group">
              <label>Person<span>*</span></label>
              <input
                name="billedToPerson"
                value={form.billedToPerson}
                onChange={handleChange}
                required
              />
            </div>
            <div className="form-group">
              <label>Organization</label>
              <input
                name="billedToOrg"
                value={form.billedToOrg}
                onChange={handleChange}
              />
            </div>
            <div className="form-group">
              <label>Address</label>
              <input
                name="billedToAddress"
                value={form.billedToAddress}
                onChange={handleChange}
              />
            </div>
            <div className="form-group">
              <label>State</label>
              <input
                name="billedToState"
                value={form.billedToState}
                onChange={handleChange}
              />
            </div>
            <div className="form-group">
              <label>Country</label>
              <input
                name="billedToCountry"
                value={form.billedToCountry}
                onChange={handleChange}
              />
            </div>
            <div className="form-group">
              <label>Contact</label>
              <input
                name="clientContact"
                value={form.clientContact}
                onChange={handleChange}
              />
            </div>
            <div className="form-group">
              <label>Email</label>
              <input
                name="clientEmail"
                value={form.clientEmail}
                onChange={handleChange}
              />
            </div>
            <div className="form-group">
              <label>GSTIN</label>
              <input
                name="clientGSTIN"
                value={form.clientGSTIN}
                onChange={handleChange}
              />
            </div>
          </div>
        </section>

        <section className="form-section">
          <h4>Training Details</h4>
          <div className="form-grid">
            {["ictName","trainerName","tcId","batchStartDate","batchStartTime",
              "batchEndDate","batchEndTime","isStandard","isPublic",
              "totalDuration","location","studyMode"
            ].map((field) => (
              <div key={field} className="form-group">
                <label>{field}</label>
                <input
                  name={field}
                  value={form[field]}
                  onChange={handleChange}
                  readOnly={field!=="status" && typeof form[field] !== "string" && !isNaN(form[field])===false}
                />
              </div>
            ))}
          </div>
        </section>

        <section className="form-section">
          <h4>Costs & Totals</h4>
          <div className="form-grid">
            {[
              "tourCost","travelCost","accommodationCost","miscCost",
              "dcCost","trainerCost","totalExpense","ictMrp",
              "ictSellPrice","gstPer","grossRev","netRev"
            ].map((field) => (
              <div key={field} className="form-group">
                <label>{field}</label>
                <input
                  name={field}
                  type="number"
                  step="0.01"
                  value={form[field]}
                  onChange={handleChange}
                  readOnly={[
                    "tourCost","travelCost","accommodationCost","miscCost","dcCost","trainerCost","totalExpense","grossRev","netRev",
                  ].includes(field)}
                />
              </div>
            ))}
            <div className="form-group">
              <label>receivingCurrency</label>
              <select
                name="receivingCurrency"
                value={form.receivingCurrency}
                onChange={handleChange}
              >
                {[
                  "INR",
                  "USD",
                  "EUR",
                  "GBP",
                  "AUD",
                  "CAD",
                  "SGD",
                  "AED",
                  "JPY",
                ].map((code) => (
                  <option key={code} value={code}>
                    {code}
                  </option>
                ))}
              </select>
            </div>
            <div className="form-group">
              <label>receivingAmt</label>
              <input
                name="receivingAmt"
                type="number"
                step="0.01"
                value={form.receivingAmt}
                onChange={handleChange}
              />
            </div>
            <div className="form-group">
              <label>inrConvertRate</label>
              <input
                name="inrConvertRate"
                type="number"
                step="0.0001"
                value={form.inrConvertRate}
                onChange={handleChange}
              />
            </div>
          </div>
        </section>

          <button type="submit" className="invoiceBtn">
            <i className="fas fa-check-circle fa-2x"></i>
          </button>
          <button type="button"onClick={onClose} className="invoiceBtn">
            <i className="fa fa-window-close fa-2x"></i>
          </button>
      </form>
      <ToastContainer position="bottom-right" autoClose={3000} />
    </div>
  );
}
